export const NOTIFICATIONS_STATUS = {
  ALL: "All",
  ACTIVE: "Active",
  OPEN: "Open",
  CLOSED: "Closed",
};

export const NOTIFICATIONS_STATUS_OPTIONS = [
  { label: NOTIFICATIONS_STATUS.ALL, value: NOTIFICATIONS_STATUS.ALL },
  { label: NOTIFICATIONS_STATUS.ACTIVE, value: NOTIFICATIONS_STATUS.ACTIVE },
  { label: NOTIFICATIONS_STATUS.OPEN, value: NOTIFICATIONS_STATUS.OPEN },
  { label: NOTIFICATIONS_STATUS.CLOSED, value: NOTIFICATIONS_STATUS.CLOSED },
];

export const NOTIFICATIONS_ACKNOWLEDGE = {
  ALL: "All",
  UNACKNOWLEDGED: "Unacknowledged",
  MYNOTIFICATIONS: "My Notifications",
};

export const NOTIFICATIONS_ACKNOWLEDGE_OPTIONS = [
  {
    label: NOTIFICATIONS_ACKNOWLEDGE.ALL,
    value: NOTIFICATIONS_ACKNOWLEDGE.ALL,
  },
  {
    label: NOTIFICATIONS_ACKNOWLEDGE.UNACKNOWLEDGED,
    value: NOTIFICATIONS_ACKNOWLEDGE.UNACKNOWLEDGED,
  },
  {
    label: NOTIFICATIONS_ACKNOWLEDGE.MYNOTIFICATIONS,
    value: NOTIFICATIONS_ACKNOWLEDGE.MYNOTIFICATIONS,
  },
];

export const NOTIFICATIONS_LIST_FITLERS = {
  search: "",
  organisationId: "",
  group: "",
  lifecycle: "",
  eventType: "",
  severity: "",
  timestampGt: "",
  resolved: NOTIFICATIONS_STATUS.ACTIVE,
  acknowledged: NOTIFICATIONS_ACKNOWLEDGE.ALL,
  paginationModel: {
    pageSize: 100,
    page: 0,
  },
  sortModel: [
    {
      field: "timestamp",
      sort: "desc",
    },
  ],
};

export const UNIT_NOTIFICATIONS_LIST_FITLERS = {
  unit: "",
  resolved: NOTIFICATIONS_STATUS.ACTIVE,
  paginationModel: {
    pageSize: 10,
    page: 0,
  },
  sortModel: [
    {
      field: "timestamp",
      sort: "desc",
    },
  ],
};

export const NOTIFICATION_OPTIONS = {
  FLEET: "Fleet",
  OWNER: "Owner",
};

export const NOTIFICATION_OPTIONS_TABS = [
  { label: "Fleet Notifications", value: NOTIFICATION_OPTIONS.FLEET },
  { label: "Owner Notifications", value: NOTIFICATION_OPTIONS.OWNER },
];

export const NOTIFICATION_ACTION = {
  ADD: "add",
  EDIT: "edit",
  DUPLICATE: "copy",
};

export const NOTIFICATION_SEVERITY_OPTIONS = [
  { label: "Informational", value: "informational" },
  { label: "Notice", value: "notice" },
  { label: "Warning", value: "warning" },
  { label: "Error", value: "error" },
];

export const NOTIFICATION_CATEGORY_OPTIONS = [
  { label: "System Fault", value: "system_fault" },
  { label: "System Operation", value: "system_operation" },
  { label: "Lifecycle Change", value: "lifecycle_change" },
  { label: "Setting Change", value: "setting_change" },
  { label: "Call to Action", value: "call_to_action" },
  { label: "Information", value: "information" },
  { label: "Promotion", value: "promotion" },
  { label: "Recommendation", value: "recommendation" },
];

export const NOTIFICATION_PRIORITY_OPTIONS = [
  { value: 10, label: 10 },
  { value: 11, label: 11 },
  { value: 12, label: 12 },
  { value: 13, label: 13 },
  { value: 14, label: 14 },
  { value: 15, label: 15 },
  { value: 16, label: 16 },
  { value: 17, label: 17 },
  { value: 18, label: 18 },
  { value: 19, label: 19 },
];

export const WEBSITE = "website";
export const APP = "app";

export const WEBSITE_URL = "https://empowerenergy.au/";
export const APP_URL = "https://demo.my.elektrobank.au/";

export const getNotificaationUrl = (item) => {
  const host = item.target === WEBSITE ? WEBSITE_URL : APP_URL;
  return `${host}${item.path}`;
};

export const getTargetUrl = (target) =>
  target === WEBSITE ? WEBSITE_URL : APP_URL;

export const NOTIFICATION_TARGET_OPTIONS = [
  { label: "Website", value: WEBSITE },
  { label: "App", value: APP },
];
